import request from './request'

export function search(data) {
    return request({
        url: '/api/order/search',
        method: 'get',
        params: data
    })
}

export function create(data) {
    return request({
        url: '/api/order/create',
        method: 'post',
        data: data
    })
}

export function delivery(data) {
    return request({
        url: '/api/order/delivery',
        method: 'post',
        data: data
    })
}

export function update(data) {
    return request({
        url: '/api/order/update',
        method: 'post',
        data: data
    })
}

export function confirm(data) {
    return request({
        url: '/api/order/confirm',
        method: 'post',
        data: data
    })
}

export function auditLog(data) {
    return request({
        url: '/api/order/auditLog',
        method: 'get',
        params: data
    })
}

export function auditRefer(data) {
    return request({
        url: '/api/order/auditRefer',
        method: 'post',
        data: data
    })
}

export function doctorConfirmTechnicianSjd(data) {
    return request({
        url: '/api/order/doctorConfirmTechnicianSjd',
        method: 'post',
        data: data
    })
}

export function doctorOrderList(data) {
    return request({
        url: '/api/order/doctorOrderList',
        method: 'get',
        params: data
    })
}
export function salemanGetOrderList(data) {
    return request({
        url: '/api/saleman/doctorOrderList',
        method: 'get',
        params: data
    })
}
